import React, { useState, useEffect, Fragment } from 'react';
import { Modal, Input, Button, message, Spin } from 'antd';
import QRCode from 'react-qr-code';
import { generateMFA, verifyMFA } from '../../../utils/mfa';
import lang from '../../../languages/en/en.json';
import './styles.css';

const MFASetup = ({ visible, onClose, onSuccess }) => {
  const [secret, setSecret] = useState('');
  const [qrCodeUri, setQrCodeUri] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    if (visible) {
      handleGenerateMFA();
    } else {
      // Reset state when modal is closed
      setSecret('');
      setQrCodeUri('');
      setVerificationCode('');
    }
  }, [visible]);

  const handleGenerateMFA = async () => {
    setGenerating(true);
    try {
      const response = await generateMFA();
      if (response.data.code === 10001) {
        setSecret(response.data.data.Secret);
        setQrCodeUri(response.data.data.QrCodeUri);
      } else {
        message.error(lang.failed_to_generate_MFA_setup);
      }
    } catch (error) {
      message.error(lang.failed_to_generate_MFA_setup);
    } finally {
      setGenerating(false);
    }
  };

  const handleVerifyMFA = async () => {
    if (!verificationCode) {
      message.error(lang.please_enter_the_verification_code);
      return;
    }

    setLoading(true);
    try {
      const response = await verifyMFA(verificationCode, secret);
      if (response.data.code === 10001) {
        message.success(lang.MFA_setup_successful);
        onSuccess();
      } else {
        message.error(lang.invalid_verification_code);
      }
    } catch (error) {
      message.error(lang.failed_to_verify_MFA_code);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Setup Two-Factor Authentication"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={400}
    >
      <div className="mfa-setup-container">
        <Spin spinning={generating}>
          <div className="qr-code-container">
            {qrCodeUri && <QRCode value={qrCodeUri} size={200} />}
          </div>
          <div className="secret-key-container">
            <p>Or enter this secret key manually:</p>
            <div className="secret-key">{secret}</div>
          </div>
          <div className="verification-input">
            <Input
              placeholder="Enter verification code"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              maxLength={6}
            />
            <Button
              type="primary"
              onClick={handleVerifyMFA}
              loading={loading}
              style={{ marginTop: 16 }}
            >
              Verify
            </Button>
          </div>
        </Spin>
      </div>
    </Modal>
  );
};

export default MFASetup;



// WEBPACK FOOTER //
// ./src/containers/auth/mfa-setup/index.js